module.exports = __webpack_public_path__ + "img/how-it-work-thumb.ad83d801.png";